<div class="pdf-preview-dialog">
    <header class="pdf-preview-header">
        <div class="pdf-preview-title">
            <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon>

            <div>
                <h2>{{ data.title }}</h2>

                @if (data.fileName) {
                <span>{{ data.fileName }}</span>
                }
            </div>
        </div>

        <div class="pdf-preview-actions">
            <button type="button" class="print-button" (click)="downloadPdf()">
                <mat-icon fontSet="material-icons-outlined">
                    download
                </mat-icon>

                @if (useNativeAppleFileSave) {
                PDF speichern
                } @else {
                PDF herunterladen
                }
            </button>

            <button type="button" class="close-button" aria-label="PDF schließen" (click)="close()">
                <mat-icon fontSet="material-icons-outlined">close</mat-icon>
            </button>
        </div>
    </header>

    <div class="pdf-preview-frame-wrapper">

        @if (useCanvasPreview) {

        @if (isPdfRendering()) {
        <div class="pdf-preview-loading">
            <mat-spinner diameter="34"></mat-spinner>

            <span>
                PDF wird geladen...
            </span>
        </div>
        }

        @if (pdfRenderError()) {
        <div class="pdf-preview-error">
            <mat-icon fontSet="material-icons-outlined">
                error_outline
            </mat-icon>

            <span>
                {{ pdfRenderError() }}
            </span>
        </div>
        }

        <div #mobilePdfContainer class="pdf-mobile-viewer">
        </div>

        } @else {

        <iframe class="pdf-preview-frame" [src]="previewUrl" title="PDF Vorschau">
        </iframe>

        }

    </div>
</div>